import moment from 'moment';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

const upperCasePattern = /(?=.*[A-Z])/;
const lowerCasePattern = /(?=.*[a-z])/;
const specialCharPattern = /(?=.*[!"#$%'&()*+,-./:;<=>?@^_`{|}~])/;
const digitPattern = /(?=.*[0-9])/;

export const passWordValidation = {
  required: value => (value && value.trim() !== '') || 'Password is required.',
  upperCaseCheck: value => value && upperCasePattern.test(value),
  lowerCaseCheck: value => value && lowerCasePattern.test(value),
  specialCharCheck: value => value && specialCharPattern.test(value),
  digitCheck: value => value && digitPattern.test(value),
  lengthCheck: value => value && value.length >= 10 && value.length <= 25
};

export const dobValidation = {
  valid: value => !value || moment(value).isValid() || 'Please enter a valid date.',
  adult: value =>
    !value ||
    moment(value).isSameOrBefore(moment().subtract(13, 'years')) ||
    'You must be over 13 to register.'
};

export const getOrGeneratePayload = async client => {
  let verifier = Cookies.get('verifier');
  const domain =
    typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname &&
    window.location.hostname.includes('jdsports')
      ? 'jdsports'
      : 'finishline';
  const ctCartJWT = Cookies.get('ctCartJWT');

  if (!verifier) {
    verifier = uuidv4();
    const cookieOptions = {
      path: '/',
      secure:
        typeof window !== 'undefined' && window.location && window.location.protocol === 'https:'
    };
    if (typeof window !== 'undefined' && window.location && window.location.hostname) {
      const hostname = window.location.hostname;
      if (hostname.includes('finishline.com') || hostname.includes('jdsports.com')) {
        cookieOptions.domain = `.${domain}.com`;
      }
    }
    Cookies.set('verifier', verifier, cookieOptions);
  }

  try {
    const sha256UUID = await sha256(verifier);
    const base64UUID = btoa(sha256UUID);
    const payload = {
      response_type: 'code',
      scope: 'read',
      code_challenge: base64UUID,
      code_challenge_method: 's256'
    };
    if (ctCartJWT) {
      payload.ctCartJWT = ctCartJWT;
    }
    return payload;
  } catch (e) {
    console.error('Error generating payload', e);
  }
};

export const sha256 = async message => {
  const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8); // convert buffer to byte array
  const hashArray = Array.from(new Uint8Array(hashBuffer)); // hash the message
  const hashHex = hashArray // convert bytes to hex string
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');

  return hashHex;
};
